import variableColors from "@/base/global/variables/figma.colors.json";
import variableTypography from "@/base/global/variables/figma.typography.json";

export const tagThemeToken: any = {
  //======================= COLOR ===========================/
  defaultBg: variableColors["ColorFigmaNeutralGrayscaleGray70"],
  defaultColor: variableColors["ColorFigmaNeutralWhiteWhite100"],
  colorBorder: variableColors["ColorFigmaNeutralGrayscaleGray40"],
  defaultColorWarning: variableColors["ColorFigmaFunctionalWarning50"],
  defaultColorSuccess: variableColors["ColorFigmaFunctionalSuccess50"],
  defaultColorError: variableColors["ColorFigmaFunctionalAlert50"],
  defaultColorProcessing: variableColors["ColorFigmaComplementaryBlue50"],

  //======================= FONT ===========================/
  fontSize: variableTypography["BodySmallFontSize"],
  fontFamily: variableTypography["BodySmallFontFamily"],
  fontSizeIcon: 12,

  //======================= SIZE ===========================/
  lineWidth: 1,
};
